import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import PendingHearings from "../components/PendingHearings";
import { useAuth } from "../auth/useAuth.hook";
import HearingsCounter from "../components/HearingsCounter";

const Dashboard: React.FC = () => {
  const { accessToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!accessToken) {
      navigate("/");
    }
  }, [accessToken, navigate]);

  return (
    <>
      <Header />
      <div className="w-full max-w-screen-2xl flex flex-col mx-auto space-y-1 pt-1">
        <HearingsCounter />
        <PendingHearings />
      </div>
    </>
  );
};

export default Dashboard;
